import { Outlet, useNavigate } from '@tanstack/react-router';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';

import { ProductContext } from '../../../types/ProductContext';
import { useRole } from '../../common/hooks/useRole';
import { client as launchDarklyClient } from '../../common/launchDarkly/launchDarklyClient';
import { useFlags } from '../../common/launchDarkly/useFlags';

export const DemandDefinitionAccessGuard = () => {
    const navigate = useNavigate();
    const role = useRole();
    const ldClient = useLDClient();
    const flags = useFlags();
    const flagsReady = !launchDarklyClient || Boolean(ldClient);
    const hasAccess =
        flags.demandDefinitionsEnabled === true &&
        (role.isSuperAdmin() ||
            (role.isCustomer() && role.context === ProductContext.LUBES && role.hasAnyAdminRights()));

    useEffect(() => {
        if (flagsReady && !hasAccess) {
            navigate({ to: '/dashboard', replace: true });
        }
    }, [flagsReady, hasAccess, navigate]);

    return flagsReady && hasAccess ? <Outlet /> : null;
};
